<template>
    <div class="heading-wrapper">
        <div class="row">
            <div class="col-xs-12 col-md-7 col-lg-5 heading-col">
                <h1 class="page-header page-header-new">
                    <i class="dev-gift header-icon"></i>
                    <br>
                    Belohnungen
                </h1>
                <div class="subheadline-div">
                    <h2>Belohne dich für deine Arbeit</h2>
                    <p>Stöber in unserem Store nach Gutscheinen, Büchern, T-Shirts und anderen Prämien.
                        Jeden <strong>1. Werktag</strong> im Monat füllen wir den Store mit coolen Belohnungen auf.
                        Da unsere Gutscheine aktuell sehr gefragt sind, musst du schnell sein.
                        Alle Belohnungen, die angezeigt werden, werden den <strong>darauffolgenden Monat wieder
                            aufgefüllt.</strong><br><br>
                        <strong>Damit noch mehr Held:innen eine Chance auf Gutscheine haben, werden wir über den Monat
                            verteilt, random weitere Gutscheine freischalten.</strong>
                    </p>
                </div>
            </div>
            <div class="col-md-5 col-lg-7 header-img-container">
                <img class="header-img pull-right"
                     src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1678201669/smashicons_rewards_present-icon-37-yellow.svg">
            </div>
        </div>
        <svg class="header-ellipse-1" width="1667" height="1233" viewBox="0 0 1667 1233" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="1059.13" cy="385.945" rx="948.196" ry="681.188" transform="rotate(10.8106 1059.13 385.945)"
                     fill="url(#paint0_linear)" fill-opacity="0.6"/>
            <defs>
                <linearGradient id="paint0_linear" x1="1059.13" y1="-295.243" x2="1059.13" y2="1067.13"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#08AB99"/>
                    <stop offset="1" stop-color="#0BC4A2" stop-opacity="0.47"/>
                </linearGradient>
            </defs>
        </svg>
        <svg class="header-ellipse-2" width="1547" height="1267" viewBox="0 0 1547 1267" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="1059.13" cy="419.945" rx="948.196" ry="681.188" transform="rotate(10.8106 1059.13 419.945)"
                     fill="url(#paint0_linear)" fill-opacity="0.6"/>
            <defs>
                <linearGradient id="paint0_linear" x1="1059.13" y1="-261.243" x2="1059.13" y2="1101.13"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#08AB99"/>
                    <stop offset="1" stop-color="#0BC4A2" stop-opacity="0.47"/>
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>

<script>

export default {
    name: "RewardScreenHeader",
}
</script>

<style scoped>
.header-img {
    margin-right: 4rem;
}

@media (max-width: 570px) {
    .heading-wrapper {
        margin-bottom: 0;
    }
}

.header-icon {
    font-size: 4rem;
    margin-left: 1rem;
}

.subheadline-div {
    margin-left: 0.5rem;
}

.header-ellipse-1 {
    position: absolute;
    top: -330px;
    right: -50px;
    z-index: -1;
    max-width: 50%;
}

.header-ellipse-2 {
    position: absolute;
    top: -360px;
    right: 0;
    z-index: -1;
    max-width: 50%;
}

.page-header-new {
    font-family: "Oswald", "Open Sans", sans-serif;
    font-weight: bold;
    font-size: 10rem;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    margin-top: 0;
}

@media (max-width: 663px) {
    .page-header-new {
        font-size: 4rem;
    }

    .heading-col {
        padding-left: 15px;
    }
}

@media (max-width: 375px) {
    .header-icon {
        font-size: 3rem;
    }

    .page-header-new {
        margin-top: 4rem;
    }
}

.header-img {
    right: -10rem;
    top: 10rem;
    overflow: hidden;
    margin-top: 8rem;
    width: 450px;
    text-align: center;
    justify-content: center;
}

@media (max-width: 1530px) {
    .header-img {
        width: 450px;
    }
}

@media (max-width: 1380px) {
    .header-img {
        width: 350px;
    }
}

@media (max-width: 1200px) {
    .header-img {
        width: 250px;
    }

}

@media (max-width: 1200px) {
    .header-img-container {
        display: none;
    }
}

@media (max-width: 930px) {
    .header-ellipse-1, .header-ellipse-2 {
        max-width: 70%;
        top: -450px;
    }
}

.feature-heading h3 {
    font-weight: bold;
    margin-left: 1rem;
    margin-top: 0;
    margin-bottom: 0;
    align-self: center;
    word-break: break-word;
}

.feature-heading svg {
    margin-left: -1rem;
    flex-shrink: 0;
}

@media (min-width: 2400px) {
    .heading-wrapper {
        margin-bottom: 5rem;
    }
}
</style>
